var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#002240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6975 8.67438L6.65125 12.7207C6.2788 13.0931 5.67494 13.0931 5.30249 12.7207C4.93004 12.3482 4.93004 11.7444 5.30249 11.3719L8.67439 8L5.30249 4.6281C4.93003 4.25565 4.93004 3.65179 5.30249 3.27934C5.67494 2.90689 6.2788 2.90689 6.65125 3.27934L10.6952 7.32333C10.696 7.32409 10.6968 7.32486 10.6975 7.32562C11.07 7.69807 11.07 8.30193 10.6975 8.67438Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVRight);
export default __webpack_public_path__ + "static/media/v-right.e99632c1cff120a38184acb9470b8a64.svg";
export { ForwardRef as ReactComponent };